__turbopack_context__.v({
  "fadeIn": "p8chMq_fadeIn",
});
